import { render, staticRenderFns } from "./DonateHome.vue?vue&type=template&id=88bb1158"
import script from "./DonateHome.vue?vue&type=script&lang=js"
export * from "./DonateHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports